import React from "react";
import { useGetUnitTasksQuery } from "core/queries/GetUnitTasks";
import { TaskPanelTaskList } from "tasks/components/TaskPanel/TaskPanelTaskList";
import {
  FilterStatus,
  SortAscDesc,
  TaskSortColumn,
} from "typings/globalGQLTypes";

interface UnitOpenTasksProps {
  cityId: string | undefined;
  taskId: string;
  unitId: string;
}

export const UnitOpenTasks = ({
  cityId,
  taskId,
  unitId,
}: UnitOpenTasksProps) => {
  const { data, loading } = useGetUnitTasksQuery({
    variables: {
      filter: {
        city: cityId,
        status: [FilterStatus.incomplete],
        unitIds: [unitId],
      },
      sort: [
        {
          column: TaskSortColumn.due_at,
          order: SortAscDesc.asc,
        },
      ],
    },
  });

  const tasks = data?.taskConnections?.tasks || [];
  const filteredTasks = tasks.filter(task => task.id !== taskId);

  return (
    <TaskPanelTaskList
      eventName="unit_tab"
      header="Open tasks"
      loading={loading}
      placeholder="There are no open tasks on the unit."
      tasks={filteredTasks}
    />
  );
};
